export const baseurl = process.env.REACT_APP_API_URL;// Dynamic config

let admin = `${baseurl}`;

const Apiconfigs = {
  // admin Login
  login: `${admin}/adminLogin`,
  forgotPassword: `${admin}/forgotPassword`,
  addCompanyDetail: `${admin}/deleteCompany`,
  forgotPassword: `${admin}/forgotPassword`,
  dashboard: `${admin}/dashboard`,
  verifyOTP: `${admin}/verifyOTPAdmin`,
  resendOTPAdmin: `${admin}/resendOTPAdmin`,
  resetPassword: `${admin}/resetPassword`,

  //profile
  getAdminProfile: `${admin}/getAdminProfile`,
  updateAdminDetails: `${admin}/updateAdminDetails`,
  changePassword: `${admin}/changePassword`,

  //users
  getallusers: `${admin}/getallusers`,
  activeBlockUserByAdmin: `${admin}/activeBlockUserByAdmin`,
  uploadFile: `${admin}/uploadFile`,
  signup: `${admin}/signup`,

  // New Admin User Management APIs
  adminUserList: `${admin}/admin/users`, // GET
  adminUserStatus: `${admin}/admin/users`, // PUT /:id/status
  adminUserDetails: `${admin}/admin/users`, // GET /:id

  //company
  getCompanyDetails: `${admin}/getcompanyDetails`,
  addCompanyDetails: `${admin}/addCompanyDetails`,
  deleteCompany: `${admin}/deleteCompany`,

  //category
  fetchallEventCatgeory: `${admin}/fetchallEventCatgeory`,
  addEventCategory: `${admin}/addEventCatgeory`,
  deleteEventCatgeory: `${admin}/deleteEventCatgeory`,

  fetchallCompanyCatgeory: `${admin}/fetchallCompanyCatgeory`,
  addCompanyCategory: `${admin}/addCompanyCatgeory`,
  deleteCompanyCategory: `${admin}/deleteCompanyCatgeory`,

  //static
  staticContent: `${admin}/staticContent`,
  createStaticContent: `${admin}/createStaticContent`,

  // block
  activeBlockcompanyByAdmin: `${admin}/activeBlockcompanyByAdmin`,

  //advertisement
  createAdvertisement: `${admin}/createAdvertisement`,
  getAdvertisements: `${admin}/getAdvertisements`,
  deleteAdvertisement: `${admin}/deleteAdvertisement`,

  //notification
  fetchallNotifications: `${admin}/fetchallNotifications`,
  createNotification: `${admin}/createNotification`,
  deleteNotification: `${admin}/deleteNotification`,

  //faq
  addFaq: `${admin}/addFaq`,
  getFaq: `${admin}/getFaq`,
  deleteFaq: `${admin}/deleteFaq`,

  //help and support
  getallhelpSupport: `${admin}/getallhelpSupport`,
  changeStatushelpSupport: `${admin}/changeStatushelpSupport`,

  //event
  getEventDetails: `${admin}/getEventDetails`,
  createEvent: `${admin}/createEvent`,
  cancelEvent: `${admin}/cancelEvent`,
  deleteEvent: `${admin}/deleteEvent`,
  approveRejectEventByAdmin: `${admin}/approveRejectEventByAdmin`,

  //dashboard
  dashboardUsersSummary: `${admin}/admin/dashboard/users-summary`,
  dashboardEventsSummary: `${admin}/admin/dashboard/events-summary`,
  dashboardCompaniesSummary: `${admin}/admin/dashboard/companies-summary`,
  dashboardAdsSummary: `${admin}/admin/dashboard/ads-summary`,
  dashboardEngagementSummary: `${admin}/admin/dashboard/engagement-summary`,
  dashboardPendingActions: `${admin}/admin/dashboard/pending-actions`,
  dashboardUserRegistrationTrend: `${admin}/admin/dashboard/user-registration-trend`,
  dashboardEventCreationTrend: `${admin}/admin/dashboard/event-creation-trend`,
};

export default Apiconfigs;
